import { select, put, call } from 'redux-saga/effects';
import { API } from '../../api';

const getIsPublic = ({ isPublic }) => isPublic;
const getServerConfig = ({ serverConfig }) => serverConfig;
const getNewLayer = ({ newCustomLayers }) => Object.values(newCustomLayers);
const getShareLayerUsers = ({ shareLayerUsers }) => shareLayerUsers;

const getPayload = (newLayers) => ({
  body: {
    key: newLayers[0].key,
    label: newLayers[0].label,
    filters: newLayers[0].filters,
    style: newLayers[0].style,
    source: newLayers[0].source,
    data_key: newLayers[0].dataKey,
  },
});

export function* saveLayer(action) {
  const serverConfig = yield select(getServerConfig);
  const newLayers = yield select(getNewLayer);
  const shareLayerUsers = yield select(getShareLayerUsers);
  const isPublic = yield select(getIsPublic);
  const { openReport } = action.payload;

  if (
    !isPublic &&
    ((newLayers.length && newLayers[0].isNew) ||
      (newLayers.length && !newLayers[0].isNew && !newLayers[0].saved))
  ) {
    const oldKey = newLayers[0].key;
    const path = `/layer/${serverConfig.namespace}`;
    const payload = getPayload(newLayers);
    const response = yield call(API, 'post', 'api', path, payload);

    yield put({
      type: 'DESELECT_LAYER',
      payload: {
        key: oldKey,
      },
    });
    yield put({
      type: 'REMOVE_LOCAL_CUSTOM_LAYERS',
      payload: {
        key: oldKey,
      },
    });

    newLayers[0] = response.layer;

    if (shareLayerUsers.length) {
      yield put({
        type: 'SHARE_LAYER',
        payload: {
          layerId: response.layer.key,
          userIds: shareLayerUsers.map((user) => user.id),
        },
      });
      newLayers[0].users = shareLayerUsers;
    }
  } else if (newLayers.length && !newLayers[0].isNew) {
    const path = `/layer/${serverConfig.namespace}/${newLayers[0].key}`;
    const payload = getPayload(newLayers);
    const response = yield call(API, 'put', 'api', path, payload);

    newLayers[0] = response.layer;
  } else {
    newLayers[0].owner = true;
  }

  yield put({
    type: 'UPDATE_CUSTOM_LAYERS',
    payload: { layers: newLayers },
  });

  if (newLayers[0] && openReport) {
    const multiParcelReport = yield select(({ reports }) => reports.find(({ id }) => id === 'MULTI_PARCEL_REPORT'));
    yield put({
      type: 'OPEN_MODAL',
      payload: {
        type: 'MULTI_PARCEL',
        data: {
          config: {
            layer: newLayers[0],
            report: multiParcelReport,
          },
        },
      },
    });
  }
  yield put({
    type: 'CLEAR_NEW_CUSTOM_LAYERS',
  });
}
